<template>
  <div class="driverTaskDetail">
    <el-drawer
      size="890px"
      :title="title"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
     <div class="tabs">
     <el-tabs v-model="active" >
    <el-tab-pane label="修改申请" name="1"></el-tab-pane>
    <el-tab-pane label="审核流程" name="2"></el-tab-pane>
  </el-tabs>
   </div>
      <!-- <div class="tabs">
        <div :class="['tab', active == 1 ? 'active' : '']" @click="active = 1">
          修改申请
        </div>
        <div :class="['tab', active == 2 ? 'active' : '']" @click="active = 2">
          审核流程
        </div>
      </div> -->
      <div v-if="active == 2">
        <div class="steps">
          <div class="step" v-for="(item, i) in flowList" :key="i">
            <div class="left">
              <div class="round"></div>
              <div class="line" v-if="i < flowList.length - 1"></div>
            </div>
            <div class="right">
              <div class="label">
                {{ item.approveUsername }}
                <div class="time">
                  {{ item.approveDatetime }}
                </div>
              </div>
              <div class="desc">
                {{ item.approveStatusText }}
              </div>
              <div class="textarea" v-if="item.approveRemark">
                {{ item.approveRemark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="active == 1">
        <avue-form :value="row" :option="commonOption"> </avue-form>
        <div class="table-header">
          <div class="block">变更前</div>
          <div class="block">变更后</div>
        </div>
        <avue-form
          ref="editForm"
          v-model="editForm"
          :option="editOption"
          @submit="(form, done) => audit(2, done)"
        >
          <template slot-scope="{ disabled, size }" slot="flow">
            <!-- <div class="approvalInfo">
              <div
                class="info"
                style="width: 400px"
                v-if="flowList && flowList.length > 0"
              >
                <div class="approvalFlow">
                  <el-timeline>
                    <el-timeline-item
                      :timestamp="item.companyPositionName"
                      placement="top"
                      class="myActive"
                      color="#409eff"
                      v-for="(item, index) in flowList"
                      :key="index"
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          margin-bottom: 10px;
                        "
                      >
                        <h4>{{ item.approveUsername }}</h4>
                        <span>{{ item.approveDatetime }}</span>
                      </div>
                      <el-input
                        type="textarea"
                        v-if="item.approveRemark"
                        v-model="item.approveRemark"
                        :autosize="{ minRows: 3, maxRows: 8 }"
                        disabled
                      ></el-input>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
              <el-empty v-else></el-empty>
            </div> -->
          </template>

          <template slot="title">
            <div class="sub-title">
              {{ this.info.type == 2 ? "回填" : "" }}出场签单信息
            </div>
          </template>
        </avue-form>
        <avue-form
          v-if="title == '审核'"
          ref="remarkForm"
          v-model="remarkForm"
          :option="remarkOpt"
          @submit="(form, done) => audit(2, done)"
        >
          <template slot="reviewRemarkTitleLabel">
            <div class="check-title">审核备注</div>
          </template>
          <template slot="reviewRemarkTitle">
            <span></span>
            <!-- <div class="check-title">审核备注</div> -->
          </template>
          <template slot="reviewRemark">
            <div class="remark">
              <textarea
                type="textarea"
                v-model="remarkForm.reviewRemark"
                placeholder="请输入审核备注"
                maxlength="100"
              ></textarea>
            </div>
          </template>
          <template slot="menuForm">
            <!-- <el-button icon="el-icon-close" @click="audit(3)">驳回</el-button> -->
            <el-button @click="audit(3)">驳回</el-button>
            <el-button @click="audit(2)" type="primary">通过</el-button>
          </template>
        </avue-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { auditUpdateHistory } from "@/api/chain/companywaybill";
import { batchAudit } from "@/api/chain/entrySignApplication";
import { getFlowNode } from "@/api/chain/companywaybillupdatehistory";
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    info: {},
    row: {},
    title: {
      type: String,
      default: "详情",
    },
  },
  data() {
    var validateRemark = (rule, value, callback) => {
      console.log(value);
      if (this.isRequired && (value === "" || !value)) {
        callback(new Error("请输入审批备注"));
      } else {
        callback();
      }
    };
    return {
      remarkForm: {},
      active: "1",
      editForm: {},
      isRequired: false,
      commonOption: {
        detail: true,
        labelPosition: "left",
        span: 8,
        column: [
          {
            label: "项目名称",
            prop: "projectName",
          },
          {
            label: "运单号",
            prop: "businessNo",
          },
          {
            label: "泥尾票土质",
            prop: "typeText",
          },
          {
            label: "申请人",
            prop: "createName",
          },
          {
            label: "申请时间",
            prop: "createDatetime",
          },
          {
            label: "审核状态",
            prop: "statusText",
          },
          {
            label: "变更原因",
            prop: "auditRemark",

            span: 24,
          },
        ],
      },
      remarkOpt: {
        labelWidth: 150,
        submitText: "通过",
        submitIcon: " ",
        submitBtn: false,
        emptyBtn: false,
        menuPosition: "right",
        column: [
          {
            label: "审核备注",
            prop: "reviewRemarkTitle",
            span: 24,
          },
          {
            label: "",
            prop: "reviewRemark",
            display: this.title == "审核",
            // type: 'textarea',
            span: 24,
            maxlength: 100,
            rules: [
              {
                validator: validateRemark,
                trigger: "blur",
              },
            ],
          },
        ],
      },
      editOption: {
        detail: true,
        submitBtn: this.title == "审核",
        labelWidth: 150,
        submitText: "通过",
        position: "left",
        emptyBtn: false,
        cancelBtn: true,
        labelPosition: "left",
        tabs: true,
        labelSuffix: " ",
        group: [
          {
            label: "变更原因",
            arrow: false,
            prop: "group2",
            column: [
              {
                label: "变更原因",
                prop: "auditRemark",
                // type: 'textarea',
                span: 24,
                className: "red",

                maxlength: 50,
              },
              // {
              //   label: "审核备注",
              //   prop: "reviewRemarkTitle",
              // },
              // {
              //   label: "",
              //   prop: "reviewRemark",
              //   display: this.title == "审核",
              //   // type: 'textarea',
              //   span: 24,
              //   maxlength: 100,
              //   rules: [
              //     {
              //       validator: validateRemark,
              //       trigger: "blur",
              //     },
              //   ],
              // },
            ],
          },
        ],
      },
      //空车重车入场的字段
      option1: {
        label: "入场签单信息",
        arrow: false,
        prop: "group1",
        tabs: false,
        column: [
          {
            label: "签单类型",
            prop: "typeText",
          },
          {
            label: "",
            prop: "typeTextAf",
            className: "red",
          },
          {
            label: "签单车牌",
            prop: "entranceTruckCode",
          },
          {
            label: "",
            prop: "entranceTruckCodeAf",
            className: "red",
          },
          {
            label: "签单票号",
            prop: "no",
          },
          {
            label: "",
            prop: "noAf",
            className: "red",
          },
          {
            label: "签单班次",
            prop: "shiftType",
          },
          {
            label: "",
            prop: "shiftTypeAf",
            className: "red",
          },
          {
            label: "班次日期",
            prop: "shiftTime",
          },
          {
            label: "",
            prop: "shiftTimeAf",
            className: "red",
          },
          {
            label: "签单员工",
            prop: "staffName",
          },
          {
            label: "",
            prop: "staffNameAf",
            className: "red",
          },
          {
            label: "签单土质",
            prop: "soilType",
          },
          {
            label: "",
            prop: "soilTypeAf",
            className: "red",
          },
          {
            label: "签单时间",
            prop: "entranceDatetime",
          },
          {
            label: "",
            prop: "entranceDatetimeAf",
            className: "red",
          },
          {
            label: "签单备注",
            prop: "entranceRemark",
          },
          {
            label: "",
            prop: "entranceRemarkAf",
            className: "red",
          },

          {
            label: "签单照片",
            prop: "entrancePicture",
            type: "upload",
            span: 12,
            listType: "picture-card",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",

            readonly: true,
          },
          {
            label: "",
            prop: "entrancePictureAf",

            type: "upload",
            span: 12,
            listType: "picture-card",
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
          },
          {
            label: "",
            prop: "title",
            row: true,
            span: 8,
            labelWidth: 0,
          },
          {
            label: "项目名称",
            prop: "waybillProjectName",
            classCol: "111",

            labelSuffix: ":",
            span: 8,
          },
          {
            label: "出场时间",
            prop: "goDatetime",

            span: 8,
          },
          {
            label: "出场签单人",
            prop: "goStaffName",
            span: 8,

            row: true,
          },
          {
            label: "泥尾票照片",
            prop: "ticketImgLabel",
            span: 8,
          },
          {
            label: "拍照票据凭证",
            prop: "goPictureLabel",
            span: 16,
          },
          {
            label: "",
            prop: "ticketImg",
            type: "upload",
            span: 8,
            listType: "picture-card",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",

            readonly: true,
            className: "big-pic",
          },
          {
            label: "",
            prop: "goPicture",

            type: "upload",
            span: 8,
            listType: "picture-card",
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
            className: "big-pic",
          },
          // {
          //   label: "审核备注",
          //   prop: "reviewRemarkTitle",
          //   span: 24,
          // },
          // {
          //   label: "",
          //   prop: "reviewRemark",
          //   display: this.title == "审核",
          //   // type: 'textarea',
          //   span: 24,
          //   maxlength: 100,
          //   rules: [
          //     {
          //       validator: validateRemark,
          //       trigger: "blur",
          //     },
          //   ],
          // },
        ],
      },
      //回填入场的字段
      option2: {
        label: "入场签单信息",
        arrow: false,
        prop: "group1",
        tabs: false,
        column: [
          {
            label: "签单类型",
            prop: "typeText",
          },
          {
            label: "",
            prop: "typeTextAf",
            className: "red",
          },
          {
            label: "签单车牌",
            prop: "truckCode",
          },
          {
            label: "签单车牌变更后",
            prop: "truckCodeAf",
            className: "red",
          },
          {
            label: "签单票号",
            prop: "no",
          },
          {
            label: "",
            prop: "noAf",
            className: "red",
          },
          {
            label: "签单班次",
            prop: "shiftType",
          },
          {
            label: "",
            prop: "shiftTypeAf",
            className: "red",
          },
          {
            label: "班次日期",
            prop: "shiftTime",
          },
          {
            label: "",
            prop: "shiftTimeAf",
            className: "red",
          },
          {
            label: "签单员工",
            prop: "operator",
          },
          {
            label: "",
            prop: "operatorAf",
            className: "red",
          },
          {
            label: "签单土质",
            prop: "soilType",
          },
          {
            label: "",
            prop: "soilTypeAf",
            className: "red",
          },
          {
            label: "签单时间",
            prop: "operateDate",
          },
          {
            label: "",
            prop: "operateDateAf",
            className: "red",
          },
          {
            label: "签单备注",
            prop: "remark",
          },
          {
            label: "",
            prop: "remarkAf",
            className: "red",
          },

          {
            label: "签单照片",
            prop: "pictureUrl",
            type: "upload",
            span: 12,
            listType: "picture-card",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",

            readonly: true,
          },
          {
            label: "",
            prop: "pictureUrlAf",

            type: "upload",
            span: 12,
            listType: "picture-card",
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
          },
          {
            label: "泥尾票照片",
            prop: "noUrl",
            type: "upload",
            span: 12,
            listType: "picture-card",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",

            readonly: true,
          },
          {
            label: "",
            prop: "noUrlAf",

            type: "upload",
            span: 12,
            listType: "picture-card",
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
          },
          {
            label: "",
            prop: "title",
            row: true,
            span: 8,
            labelWidth: 0,
          },
          {
            label: "项目名称",
            prop: "waybillProjectName",
            span: 8,
          },
          {
            label: "出场时间",
            prop: "goDatetime",
            span: 8,
          },
          {
            label: "出场签单人",
            prop: "goStaffName",
            span: 8,

            row: true,
          },
          {
            label: "泥尾票照片",
            prop: "ticketImg",
            span: 8,
            type: "upload",
            span: 24,
            listType: "picture-card",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",

            readonly: true,
          },
          {
            label: "拍照票据凭证",
            prop: "goPicture",
            span: 8,

            type: "upload",
            span: 24,
            listType: "picture-card",
            tip: "只能上传jpg/png文件",
            action: "/upms/file/upload?fileType=image&dir=",
            dataType: "string",
            propsHttp: {
              url: "link",
            },
          },
          // {
          //   label: "审核备注",
          //   prop: "reviewRemark",
          //   display: this.title == "审核",
          //   span: 24,
          //   maxlength: 100,
          //   rules: [
          //     {
          //       validator: validateRemark,
          //       trigger: "blur",
          //     },
          //   ],
          // },
        ],
      },
      flowForm: {
        label: "审核流程",
        arrow: false,
        prop: "group3",
        column: [
          {
            label: "",
            prop: "flow",
            labelWidth: 0,
            span: 24,
          },
        ],
      },
      statusForm: {},
      flowList: [],
    };
  },
  created() {},
  mounted: function () {
    this.editForm = this.info;
    console.log(this.editForm);
    // 判断空车重车及回填的字段
    this.editOption.group.unshift(
      this.info.type == 2 ? this.option2 : this.option1
    );
    //查看增加审核流程
    if (this.title != "审核") {
      this.editOption.group.push(this.flowForm);
    }
    //获取审批流程信息
    getFlowNode(this.info.id).then((res) => {
      this.flowList = res.data.data;
    });
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    cancelModal() {
      this.$emit("update:visible", false);
    },
    audit(type, done) {
      if (type == 3) {
        this.isRequired = true;
        console.log(this.$refs.editForm);
        this.$refs.remarkForm.validateField("reviewRemark");
        this.isRequired = false;
        if (!this.remarkForm.reviewRemark) {
          this.$message.error("请输入审核备注");
          done && done();
          return false;
        }
      }
      // type 2审核通过  3驳回
      this.$confirm(`确认${type == 2 ? "通过" : "驳回"}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          batchAudit({
            list: [{ id: this.editForm.id, type: this.editForm.type }],
            status: type,
            auditRemark: this.remarkForm.reviewRemark,
          })
            .then((res) => {
              loading.close();
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.$emit("update:visible", false);
              this.$emit("searchData");
            })
            .catch(() => {
              loading.close();
            });
        })
        .catch(() => {});
      done && done();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-drawer__header {
  margin-bottom: 0;
}

/deep/ .drawerHeader {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

/deep/ .red {
  .el-form-item__content input {
    color: #35b1ff !important;
  }

  .is-checked .el-radio__label {
    color: #35b1ff !important;
  }

  .is-checked .el-radio__inner {
    border-color: #35b1ff;

    &::after {
      background-color: #35b1ff;
    }
  }
}

.el-timeline-item__timestamp {
  color: #333;
}

.el-timeline-item__content {
  color: #909399;
}

.myActive .el-timeline-item__tail {
  border-left: 2px solid #409eff;
}
.tabs {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 32px;
  padding-bottom: 0;
  padding-top: 20px;
  .tab {
    font-weight: 500;
    font-size: 14px;
    color: #313133;
    &:first-child {
      margin-right: 56px;
    }
    &.active {
      color: #35b1ff;
    }
  }
}
/deep/.el-collapse-item__wrap .avue-form__group--flex {
  background: #fff !important;
  margin-top: -25px;
}
// /deep/.el-tabs__header {
//   display: none;
// }
.custom-label {
  background: #F5F7FA;
  width: 100%;
}
.custom-value {
  background: #F5F7FA;
}
/deep/.el-form-item__label {
  padding-right: 0;
  padding-left: 30px;
}
/deep/.avue-form__group .el-col {
  padding: 0 !important;
}
.table-header {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 0 32px;
  .block {
    width: 50%;
    text-align: center;
    background: #ededf0;
    font-weight: 500;
    padding-right: 40px;
    font-size: 14px;
    color: #313133;
  }
}
/deep/.el-collapse-item__wrap {
  // display: none;
}
/deep/.avue-form__group .el-col-12 {
  border-bottom: 1px solid #ededf0;
}
/deep/.el-form-item {
  margin-top: 5px;
  margin-bottom: 5px !important;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
  width: 48px;
  height: 48px;
  margin: 0;
}
/deep/.avue-upload {
  margin-left: 8px;
}
.sub-title {
  margin-top: 26px;
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 14px;
  color: #313133;
}
/deep/.avue-form__group .el-col-8 {
  .el-form-item__label {
    padding-left: 0;
    width: auto !important;
  }
  .el-form-item {
    display: flex;
    // align-items: center;
    margin-bottom: 0 !important;

    .el-form-item__label {
      // line-height: 20px;
      padding-right: 0;
      white-space: nowrap;
      width: auto !important;
    }
    .el-form-item__content {
      margin-left: 0 !important;
      padding-left: 0;
    }
  }
}
/deep/.el-drawer .avue-form {
  padding: 0 32px;
}
/deep/.avue-form__group .el-col-16 {
  .el-form-item__label {
    padding-left: 0;
    width: auto !important;
  }
}
/deep/.avue-form__group .el-col-24 {
  .el-form-item__label {
    padding-left: 0;
    width: auto !important;
  }
  .el-form-item {
    display: flex;
    // align-items: center;
    margin-bottom: 0 !important;

    .el-form-item__label {
      // line-height: 20px;
      padding-right: 0;
      white-space: nowrap;
      width: auto !important;
    }
    .el-form-item__content {
      margin-left: 0 !important;
      padding-left: 0;
      width: 100%;
    }
  }
}
.steps {
  padding: 0 48px;
  .step {
    // height: 100px;
    display: flex;
    padding-bottom: 24px;
    .left {
      .round {
        width: 4px;
        height: 4px;
        border: 2px solid #35b1ff;
        border-radius: 50%;
        margin: 8px 0;
      }
      .line {
        margin-left: 3px;
        width: 2px;
        height: 100%;
        background: #35b1ff;
      }
    }
    .right {
      width: 100%;
      margin-left: 20px;
      .label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 16px;
        color: #313133;
        margin-bottom: 4px;
        .time {
          font-weight: 400;
          font-size: 14px;
          color: #626266;
        }
      }
      .desc {
        font-weight: 400;
        font-size: 14px;
        color: #626266;
        margin-bottom: 8px;
      }
      .textarea {
        padding: 6px 10px;
        height: 88px;
        width: 100%;
        background: #F5F7FA;
        border-radius: 2px;
        border: 1px solid #ededf0;
        font-weight: 400;
        font-size: 14px;
        color: #939399;
      }
    }
  }
}
.check-title {
  font-weight: 500;
  font-size: 16px;
  color: #313133;
  margin-bottom: 15px;
}
.remark {
  width: 100%;

  textarea {
    border: 1px solid #ededf0;
    height: 88px;
    width: 100%;
    background: #ffffff;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 6px 10px;
  }
}
/deep/.big-pic {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 160px;
    height: 90px;
  }
  .avue-upload{
    margin-left: 0;
  }
}
/deep/.el-drawer__header{
  border-bottom: 1px solid #EDEDF0;
  padding: 11px 20px;
}
/deep/.avue--detail{
  .el-tabs__header {
  display: none;
}
}
</style>
